import { NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatLegacySliderModule as MatSliderModule } from '@angular/material/legacy-slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
  OWL_DATE_TIME_LOCALE,
  OwlDateTimeIntl
} from '@danielmoncada/angular-datetime-picker';
import { PlatformModule } from '@angular/cdk/platform';
import { ObserversModule } from '@angular/cdk/observers';
import { getPaginatorIntl } from './_helpers/paginator.translate';

// class OwlDateTimeIntlPl extends OwlDateTimeIntl {
//   upSecondLabel = 'Add a second';
//   downSecondLabel = 'Minus a second';
//   upMinuteLabel = 'Add a minute';
//   downMinuteLabel = 'Minus a minute';
//   upHourLabel = 'Add a hour';
//   downHourLabel = 'Minus a hour';
//   prevMonthLabel = 'Previous month';
//   nextMonthLabel = 'Next month';
//   prevYearLabel = 'Previous year';
//   nextYearLabel = 'Next year';
//   prevMultiYearLabel = 'Previous 21 years';
//   nextMultiYearLabel = 'Next 21 years';
//   switchToMonthViewLabel = 'Change to month view';
//   switchToMultiYearViewLabel = 'Choose month and year';
//   cancelBtnLabel = 'Anuluj';
//   setBtnLabel = 'Ustaw';
//   rangeFromLabel = 'Od';
//   rangeToLabel = 'Do';
//   hour12AMLabel = 'AM';
//   hour12PMLabel = 'PM';
// }

/**
 * NgModule that includes all Material modules that are required to serve the demo-app.
 */
@NgModule({
  exports: [
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatSlideToggleModule,
    MatExpansionModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatGridListModule,
    MatRadioModule,
    MatSliderModule,
    MatCheckboxModule,
    MatDialogModule,
    MatBadgeModule,
    MatTooltipModule,

    OwlDateTimeModule,
    OwlNativeDateTimeModule,

    ObserversModule,
    PlatformModule
  ],
  providers: [
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'pl' },
    // { provide: OwlDateTimeIntl, useClass: OwlDateTimeIntlPl },
    { provide: MatPaginatorIntl, useValue: getPaginatorIntl() }
  ]
})
export class CustomMaterialModule {}
